export default __webpack_public_path__ + "images/53_1_image.jpg";